import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import { Helmet } from "react-helmet";

const NewsDetail = () => {
  const { slug } = useParams(); // Get slug from URL
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getArticleBySlug/${slug}`);
        if (response.data.success && response.data.article) {
          setArticle(response.data.article);
        } else {
          setError("Article not found.");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching article:", error);
        setError("Error fetching article.");
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <span className="loader"></span>
        <p className="ms-3">Loading Article...</p>
      </div>
    );
  }

  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <>
      <Helmet>
        <title>{article.seo_title || article.title}</title>
        <meta name="description" content={article.seo_description || article.summary} />
        <meta name="keywords" content={article.seo_keywords || ""} />
        <link rel="canonical" href={`https://evventoz.com/article/${article.slug}`} />
      </Helmet>

      <NavbarVisitor />

      <div className="container-fluid">
<img
              src={article.featured_image}
              alt={article.title}
              className="img-fluid rounded mb-4"
              style={{ maxHeight: "250px", objectFit: "cover", width: "100%" }}
            />
      </div>

      <div className="container my-5 text-start">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h1 className="mb-3">{article.title}</h1>
            <p className="text-muted">
              <strong>By:</strong> {article.author_name} &nbsp;|&nbsp;
              <strong>Updated:</strong>{" "}
              {new Date(article.updated_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </p>

            

            <div
              className="article-content"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NewsDetail;
